import { EventParams } from '../Analytics/Event.types';

declare const window: Window & {
  clarity: any;
};

export class Clarity {
  private _clarity?: (...args: unknown[]) => void;

  constructor(id?: string) {
    this._clarity = undefined;

    this.initializeInstance(id || process.env.REACT_APP_CLARITY_ID);
  }

  public initializeInstance(clarityId?: string) {
    if (!clarityId)
      return console.error(
        'You need to specify a clarity id for initializing it.'
      );
    if (typeof window === 'undefined' || typeof document === 'undefined')
      return;

    window.clarity =
      window.clarity ||
      function() {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };

    this._clarity = window.clarity;

    const scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = 'https://www.clarity.ms/tag/' + clarityId;

    const taggedElement = document.getElementsByTagName('script')?.[0];
    taggedElement.parentNode?.insertBefore(scriptElement, taggedElement);
  }

  public setCustomId(id: string | number) {
    if (!this._clarity) return;
    this._clarity('custom-id', String(id));
  }

  public setCustomTag(key: string, value: string | string[]) {
    if (!this._clarity) return;
    this._clarity('set', key, value);
  }

  public setIdentifier(
    email: string,
    session?: string,
    page?: string,
    userHint?: string
  ) {
    if (!this._clarity) return;
    this._clarity('identify', email, session, page, userHint);
  }

  public logEvent(eventName: string, eventParams?: EventParams) {
    if (!this._clarity) return;
    this._clarity('event', eventName, eventParams);
  }
}
